import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ImportCloudProjectsOdxTableComponent } from "@components/cloud-project-odx-tables/import-cloud-projects-odx-table/import-cloud-projects-odx-table.component";
import { ProjectApiService } from "@domain/project/api/project-api.service";
import { CloudProjectMetadata } from "@domain/project/cloud-project-metadata";
import { ProjectService } from "@domain/project/project.service";
import { ModalRef } from "@odx/angular/components/modal";
import { forkJoin, Observable } from "rxjs";

@Component({
  templateUrl: "./cloud-project-select-modal.component.html",
  styleUrls: ["./cloud-project-select-modal.component.scss"],
  imports: [UiKitModule, ImportCloudProjectsOdxTableComponent],
  standalone: true,
})
export class CloudProjectSelectModalComponent {
  private projectService = inject(ProjectService);
  private apiService = inject(ProjectApiService);

  private readonly modalRef = inject(ModalRef<any, string>);

  cloudProjects$: Observable<CloudProjectMetadata[]>;
  selectedProject?: CloudProjectMetadata;

  constructor() {
    const projectService = this.projectService;

    this.cloudProjects$ = projectService.loadCloudProjectsMetadata();
  }

  onConfirm() {
    if (!this.selectedProject) {
      return undefined;
    }
    const cloudId = this.selectedProject.id;

    return forkJoin({
      project: this.projectService.loadProjectFromCloud(cloudId),
      metadata: this.apiService.getMetadata(cloudId),
    }).subscribe({
      next: ({ project: project, metadata: metadata }) => {
        this.modalRef.close({ project: project, metadata: metadata });
      },
    });
  }
}
